<template>
  <div
    class="org-course-card"
    @click="goDetail(courseInfo.id)"
    :class="{
      'hidden-ios': iosInReview && courseInfo.goods.price > 0,
      'electron-course-card': isElectron,
      'h5-org-course-card': isH5,
    }"
  >
    <div class="cover-wrap">
      <img
        class="cover"
        :src="courseInfo.cover_url + '?imageView2/0/w/560'"
        alt=""
      />
      <CourseStatusTag
        :liveState="courseInfo.live_state || 0"
        :trialState="courseInfo.trial_state || 0"
      />
    </div>
    <div class="course-info">
      <p class="course-title">
        <span v-if="courseInfo.category_name" class="course-tag">
          {{ courseInfo.category_name }}</span
        >{{ courseInfo.course_name }}
      </p>
      <div class="item-bottom">
        <div class="left-wrap">
          <!-- 价格 -->
          <div v-if="courseInfo.goods" class="price-wrap">
            <!--免费 -->
            <span v-if="courseInfo.goods.fee_type === 1" class="free-price"
              >免费</span
            >
            <Price
              v-else
              :size="priceSize"
              :activePrice="courseInfo.activetyPrice * 100"
              :originPrice="courseInfo.originPrice"
            />
          </div>
          <!-- 营销标识 -->
          <p class="activity-mark" v-if="activityText">
            {{ activityText }}
          </p>
        </div>
        <!-- 课时信息 -->
        <p class="data-STATS">
          <span class="lesson">{{ courseInfo.lesson_count }}课时</span>
          <span
            style="display: flex; align-items: center"
            v-if="
              courseInfo.goods && courseInfo.goods.show_enrollment_count === 1
            "
            ><span class="separate"></span
            >{{ million(courseInfo.enrollment_count) }}人报名</span
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { isH5, Price, CourseStatusTag, isMobile } from "@saas/components";
import courseCard from "@saas/components/src/mixins/courseCard";
import { million } from "@saas/components/src/utils/utils";
export default {
  mixins: [courseCard],
  props: {
    courseInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data: function () {
    return {
      isH5: isH5(),
      million,
      isElectron: window.isElectron,
      isMobile: isMobile(),
    };
  },
  methods: {
    goDetail(id) {
      let url = `/product-detail/${id}`;
      if (this.iosInReview) {
        this.$router.push(`${url}?inReview=1`);
      } else if (window.isElectron || this.isMobile) {
        this.$router.push(url);
      } else {
        window.open(url);
      }
    },
  },
  created() {
    this.iosInReview = this.$route.query.inReview === "1";
  },
  components: {
    Price,
    CourseStatusTag,
  },
};
</script>

<style lang="scss" scoped>
.hidden-ios {
  display: none !important;
}
.org-course-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  .cover-wrap {
    position: relative;
  }
  .cover {
    width: 356px;
    height: 200.25px;
    margin: 0 auto;
    border-radius: 16px;
    margin-bottom: 8px;
    object-fit: cover;
  }
  .course-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .course-title {
    font-weight: 500;
    font-size: 18px;
    color: $saas-text-color;
    line-height: 28px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-break: anywhere;
    .course-tag {
      position: relative;
      top: -1px;
      display: inline-block;
      height: 18px;
      background: #f5f5f5;
      border-radius: 4px;
      font-weight: 500;
      font-size: 12px;
      color: $plain-text-color;
      line-height: 18px;
      text-align: center;
      margin-right: 5px;
      padding: 0 5px;
    }
  }
  .item-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .data-STATS {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: $saas-text-color;
    line-height: 20px;
    .separate {
      display: inline-block;
      width: 1px;
      height: 8px;
      background: #e9e9e9;
      margin: 2px;
    }
  }
  .left-wrap {
    display: flex;
    align-items: center;
    .activity-mark {
      display: flex;
      align-items: center;
      font-size: 12px;
      line-height: 16px;
      color: $saas-price-color;
      height: 24px;
      border-radius: 8px;
      border: 1px solid rgba($color: $saas-price-color, $alpha: 0.3);
      padding: 0 3px;
    }
    .price-wrap {
      .free-price {
        font-weight: 600;
        font-size: 22px;
        color: $saas-price-color;
        line-height: 1;
      }
    }
  }
}

// 客户端
.electron-course-card.org-course-card {
  .cover {
    width: 286px;
    height: 160px;
    border-radius: 13px;
    margin-bottom: 5px;
  }
  .course-title {
    font-size: 14px;
    line-height: 22px;
    .course-tag {
      position: relative;
      top: -1px;
      height: 16px;
      border-radius: 3px;
      display: inline-block;
      font-weight: 500;
      font-size: 10px;
      color: #515350;
      line-height: 14px;
      text-align: center;
      margin-right: 5px;
      padding: 0 5px;
    }
  }
  .left-wrap {
    .activity-mark {
      font-size: 10px;
      line-height: 16px;
      height: 18px;
      border-radius: 6px;
      padding: 0 2px;
    }
    .free-price {
      font-size: 18px;
    }
  }
  .data-STATS {
    font-size: 10px;
    color: #0d1400;
    line-height: 20px;
  }
}

// h5
.org-course-card.h5-org-course-card {
  .cover {
    width: 8.72rem;
    height: 5.01rem;
    margin: 0 auto;
    border-radius: 0.32rem;
    margin-bottom: 0.21rem;
  }
  .course-info {
    padding-bottom: 0.32rem;
  }
  .course-title {
    font-weight: 500;
    font-size: 0.4rem;
    color: #0d1400;
    line-height: 0.56rem;
    line-break: anywhere;
    -webkit-line-clamp: 1;
    .course-tag {
      height: 0.43rem;
      border-radius: 0.11rem;
      text-align: center;
      margin-right: 0.11rem;
      padding: 0 0.1rem;
      font-weight: 400;
      font-size: 0.29rem;
      color: #515350;
      line-height: 0.43rem;
    }
  }
  .left-wrap {
    .activity-mark {
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 400;
      font-size: 0.29rem;
      line-height: 0.43rem;
      // width: 1.39rem;
      height: 0.43rem;
      border-radius: 0.11rem;
      padding: 0 0.11rem;
    }
    .price-wrap {
      .free-price {
        font-size: 0.37rem;
      }
    }
  }
  .data-STATS {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 0.29rem;
    color: #515350;
    line-height: 0.4rem;
    .separate {
      margin: 0 0.05rem;
    }
  }
}
</style>
